function live_filter() {

    let container = document.querySelector('.live_filter'),
        char_limit_low = 3;

    if(container) {
        let input = container.querySelector('input'),
            // item_container = container.querySelector('.consumables'),
            item_container = (input.getAttribute('data-container') == '.product_grid') ? document.querySelector('.product_grid > div:last-child') : document.querySelector(input.getAttribute('data-container'));
            items = item_container.querySelectorAll('[data-nice]');

        input.addEventListener('keyup', (event) => {
            if( input.value.length >= char_limit_low ) {
                let val = input.value.toLowerCase();

                items.forEach( element => {
                    let nice = element.getAttribute('data-nice');
                    if( nice.includes(val) ) {
                        element.setAttribute('data-active', 1);
                    } else {
                        element.removeAttribute('data-active');
                    }
                });
            } else {
                items.forEach( element => {
                    element.setAttribute('data-active', 1);
                });
            }
        });
    }
        


}

live_filter();